// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_2eGgAbwxhtlfYBthfN9hyF","list":"_2moQnrdK07oGWFHPf3_bXI"};